export const TOAST_MESSAGES = {
    FETCH_KPI_FAILED: "Failed to Fetch KPIs",
    FETCH_COMPLETION_FAILED: "Failed to Fetch Project completion percent.",
    FETCH_BILL_SUMMARY: "Failed to Fetch Bills Summary.",
    FETCH_APPROVALS_FAILED: "Failed to fetch Approvals",
    FETCH_CHECKLIST_FAILED: "Failed to fetch Check-list",
    FETCH_ANNOUNCEMENT_FAILED: "Failed to fetch Announcement",
}
export const formatAmountINR = (value, currency = "₹") => {
  if (value === null || value === undefined) return "-";

  let formatted = "";
  if (value >= 1_00_00_000) {       // 1 Crore
    formatted = `${(value / 1_00_00_000).toFixed(2)} Cr`;
  } else if (value >= 1_00_000) {   // 1 Lakh
    formatted = `${(value / 1_00_000).toFixed(2)} L`;
  } else if (value >= 1_000) {      // Thousands
    formatted = `${(value / 1_000).toFixed(2)}k`;
  } else {
    formatted = value.toString();
  }

  return `${currency}${formatted}`;
};